import { useState } from "react";
import { Building2, Route } from "lucide-react";
import { JourneyTimeline } from "./JourneyTimeline";
import { HotelConfigurator } from "./HotelConfigurator";

type View = "configurator" | "journey";

export const HeroInteractive = () => {
  const [activeView, setActiveView] = useState<View>("configurator");

  return (
    <div className="space-y-4">
      <div className="flex justify-center">
        <div className="inline-flex p-1 bg-secondary/50 rounded-full backdrop-blur-sm border border-border/50">
          <button
            onClick={() => setActiveView("configurator")}
            className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-all ${
              activeView === "configurator"
                ? "bg-background text-foreground shadow-sm"
                : "text-muted-foreground hover:text-foreground"
            }`}
          >
            <Building2 className="w-4 h-4" />
            Build Your Hotel
          </button>
          <button
            onClick={() => setActiveView("journey")}
            className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-all ${
              activeView === "journey"
                ? "bg-background text-foreground shadow-sm"
                : "text-muted-foreground hover:text-foreground"
            }`}
          >
            <Route className="w-4 h-4" />
            See the Journey
          </button>
        </div>
      </div>

      <div className="relative">
        <div
          className={`transition-all duration-300 ${
            activeView === "configurator"
              ? "opacity-100 translate-y-0"
              : "opacity-0 translate-y-2 absolute inset-0 pointer-events-none"
          }`}
        >
          <HotelConfigurator />
        </div>
        <div
          className={`transition-all duration-300 ${
            activeView === "journey"
              ? "opacity-100 translate-y-0"
              : "opacity-0 translate-y-2 absolute inset-0 pointer-events-none"
          }`}
        >
          <JourneyTimeline />
        </div>
      </div>
    </div>
  );
};
